module.exports = __webpack_public_path__ + "static/media/rondas.36d555ee.jpg";